import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {DocumentType} from 'types/documents';
import {toSnakeCase} from 'utils/object';
import {request} from 'utils/request-axios';
import {TaxCombination} from 'utils/tax';

import {TaxCombinationWithId} from './types';

export type FormFields = {
    alternateTaxRate: string;
    defaultTaxRate: string;
    enableJpWithholdingTax: boolean;
    taxCombinations: TaxCombinationWithId[];
};
export type Request = {
    alternateTaxRate: null | string;
    defaultTaxRate: string;
    enableJpWithholdingTax: boolean;
    taxCombinations?: ({mid?: string} & TaxCombination)[];
};

export type FavoriteTaxCombinationsSuccessResponse =
    Api.Response.Success<Api.Response.Template.SuccessBasicMessage>;

export type FavoriteTaxCombinationsErrorResponse = Api.Response.Failure<{
    [K in DocumentType]: boolean;
}>;

export const usePutTaxCombinationsEdit = (): UseMutationResult<
    FavoriteTaxCombinationsSuccessResponse,
    FavoriteTaxCombinationsErrorResponse,
    Request
> => {
    const locale = useLocale();

    return useMutation((formData) =>
        request({
            formData: toSnakeCase(formData),
            locale,
            method: 'PUT',
            url: '/home/partner/tax-settings/edit/',
        }),
    );
};
